/* eslint-disable @typescript-eslint/no-explicit-any */
import { isPlatformServer } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { COMMON_CONFIG } from '../../tokens/common-config.token';
import { checkUpdatedActiveCookieCategories } from '../../utils/cookie/cookie-helpers.util';

@Injectable({ providedIn: 'root' })
export class CookieProService {
  private readonly config = inject(COMMON_CONFIG);
  private readonly platformId = inject(PLATFORM_ID);

  readonly initializeCookiePro = () => {
    if (isPlatformServer(this.platformId)) {
      return Promise.resolve();
    }

    if (!this.config.cookiePro) {
      return Promise.resolve();
    }

    const head = document.head;

    if (this.config.cookiePro.autoBlockScript) {
      const autoBlockScript = document.createElement('script');
      autoBlockScript.src = this.config.cookiePro.autoBlockScript;
      head.insertBefore(autoBlockScript, head.childNodes[0]);
    }

    const script = document.createElement('script');
    script.src = this.config.cookiePro.src;
    script.setAttribute(
      'data-domain-script',
      this.config.cookiePro.domainScript,
    );
    script.setAttribute('data-document-language', 'true');

    head.insertBefore(script, head.childNodes[0]);

    let currentCookieCategories: string[] = [];
    (window as any).OptanonWrapper = () => {
      const activeCookieCategories = (window as any).OnetrustActiveGroups.split(
        ',',
      ).filter((g: string) => g);
      currentCookieCategories = checkUpdatedActiveCookieCategories(
        currentCookieCategories,
        activeCookieCategories,
      );
    };

    return Promise.resolve();
  };
}
